const LOCAL_STORAGE_KEY = 'pj:recentSearches';
const LIMIT = 5;

export const getRecentSearches: () => string[] = () => {
  try {
    const previousSearches = localStorage.getItem(LOCAL_STORAGE_KEY);
    return previousSearches ? JSON.parse(previousSearches).reverse() : [];

    // eslint-disable-next-line no-empty
  } catch {}

  return [];
};

export const deleteRecentSearch = (query: string) => {
  const previousSearches = getRecentSearches();
  const queries = new Set();

  if (previousSearches) {
    previousSearches.forEach(queries.add, queries);
    queries.delete(query);
  }

  try {
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify([...queries].reverse())
    );
  } catch {
    // Swallow the exception
  }
};

export const addRecentSearch = (query: string) => {
  if (!query || query.length < 2) {
    return;
  }

  const trimmed = query.trim();

  try {
    const previousSearches = getRecentSearches();
    const queries = new Set();

    if (previousSearches) {
      previousSearches.reverse().forEach(queries.add, queries);
    }

    // Move existing query to the top as most recent
    if ([...queries].includes(trimmed)) {
      queries.delete(trimmed);
    }

    queries.add(trimmed);

    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify(
        [...queries]
          .reverse()
          .slice(0, LIMIT)
          .reverse()
      )
    );

    // eslint-disable-next-line no-empty
  } catch (e) {}
};

export const clearRecentSearches = () => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify([]));

    // eslint-disable-next-line no-empty
  } catch {}
};
